import { axiosInstance } from "./AxiosInterceptor";
import { backendConfig } from "../config/BackendConfig";

/**
 * @param {
 *  tenantId: string [userCognitoData.username],
 *  size: number [number of records needed],
 *  from: number ,
 *  sort: array Ex:-[{ DeviceName: "asc" }]
 * } queryParam
 * @returns Promise
 */
export const getAllDeviceList = (queryParam) => {
  /**End Point:- getDevicesUsingelasticSearch**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.getDevices,
    queryParam
  );
};

/**
 * @param {
 *  deviceId: string,
 *  size: number [number of records needed],
 *  pageNo: number ,
 *  sort: array  [{"eventDate": "DESC" }]
 *  filters: object {eventDate : {"between": [from-to]}}
 * } queryParam
 * @returns Promise
 */
export const getDeviceTelemetry = (queryParam) => {
  /**End Point:- getDeviceTelemetry**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.getDeviceTelemetryForList,
    queryParam
  );
};


export const updateLocationOfDevice = (queryParam) => {
  /**End Point:- updateDeviceLocation**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.updateDeviceLocation,
    queryParam
  );
};


export const createDeviceEntry = (queryParam) => {
  /**End Point:- createDeviceEntry**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.createDevice,
    queryParam
  );
};

export const performModeChange = (queryParam) => {
  /**End Point:- performModeChange**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.performModeChange,
    queryParam
  );
};

export const performDeviceWifiConfigOperations = (queryParam) => {
  /**End Point:- performDeviceWifiConfigOperations**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.performDeviceWifiConfigOperations,
    queryParam
  );
};

